'use strict';

angular.module('app.influencerChannelList', [])

.controller('influencerChannelListCtrl', ['$scope', '$rootScope', '$http', '$state', '$modal', 'localStorageService', 'adminService', function ($scope, $rootScope, $http, $state, $modal, localStorageService, adminService) {
        $scope.currentUser = $rootScope.currentUser;
        $scope.allChannelsData = [];
        $scope.limitChannelList = 5;
        $scope.showAllChannel = false;

        $scope.loadInfluencerChannelList = function() {
            var url_getAllChannels = $rootScope.apiUrl + 'influencer/getInfluencerInformation/' + $scope.currentUser.company.id;
            $http.get(url_getAllChannels)
                .success(function (response) {
                    $rootScope.influencerInformation = response.data;
                    localStorageService.set('influencerInformation', $rootScope.influencerInformation);
                    $scope.allChannelsData = $rootScope.influencerInformation.influencerChannels;
                })
                .error(function (error) {
                    return typeof(data) != "undefined" ? {
                        status: 'ok',
                        message: data.message
                    } : {status: 'ok', message: 'Failed to load user data...'};
                })
        }

        $scope.PlatformIcon = function (platform_id) {
            return adminService.getPlatformIcon(platform_id);
        }

        if($scope.currentUser.accessibility.leftMenu.showChannels == true) {
            $scope.allChannelsData = $rootScope.influencerInformation.influencerChannels;
        }

        $scope.$on('refreshInfluencerChannel', function(event, args){
            $scope.loadInfluencerChannelList();
        })

        $scope.markChannel = function(id) {
            $(".channels ul li").removeClass('activePreferred');
            $(".channels ul li#channel_" + $rootScope.sideMenuSelections.channel).addClass('activePreferred');
        }

        $scope.channelSidebar_selectChannel = function(id){

            $scope.markChannel(id);

            $rootScope.sideMenuSelections.project = null;
            $rootScope.sideMenuSelections.keyword = null;
            $rootScope.sideMenuSelections.blog = null;
            $rootScope.sideMenuSelections.channel = id;           
            $rootScope.sideMenuSelections.influencerGroup = null;            

            $rootScope.saveParams = {
                project_id : 0,
                mention : 0,
                blog_id : 0,
                channel: id ? id : 0,
                influencerGroup: 0,
                _workaround_group_id: 0
            };

            $rootScope.$broadcast('refreshDashboard', {});

            if($state.current.name == "home.influencerOverview" || $state.current.name == "home.blogPostOverview" || $state.current.name == "home.instagramPostOverview" || $state.current.name == "home.youtubePostOverview") {
                $state.transitionTo("home.dashboard", null, {
                    reload: false,
                    inherit: false,
                    notify: true
                });
            }
        }

        $scope.channelSidebar_toggleAll = function(e){
            $(e.target).text($scope.showAllChannel ? 'Show All' : 'Hide');
            $scope.showAllChannel = !$scope.showAllChannel;
        }

        $scope.newChannelModalHandler = function () {
            $state.transitionTo("home.profileManageChannels", null, {
                reload: false,
                inherit: false,
                notify: true
            });

            var channelModalInstance = $modal.open({       
                scope: $scope,    
                templateUrl: 'app/profile/influencerManageChannels/partials/influencer-add-channel.html?app_v=deployDate',
                controller: 'NewInfluencerChannelCtrl'
            });

            $scope.channelModalInstance = channelModalInstance;
            $scope.index = null;
            channelModalInstance.result.then(function(result){  
                if(result != null){
                    $rootScope.$broadcast('refreshInfluencerChannel');
                }               
            },function(){
                //
            });
        };

    }])